import invoiceApi from 'api/invoiceApi'
import Global from 'general/utils/Global'

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit')

export const thunkGetProfile = createAsyncThunk(
  '/input-invoice/getProfile',
  async (params, thunkApi) => {
    const res = await invoiceApi.getProfile(params)
    return res
  },
)
export const thunkCreateNewOrganization = createAsyncThunk(
  '/input-invoice/createNewOrganization',
  async (params, thunkApi) => {
    const res = await invoiceApi.createNewOrganization(params)
    return res
  },
)
export const thunkConnectCQT = createAsyncThunk(
  '/input-invoice/connectCQT',
  async (params, thunkApi) => {
    const res = await invoiceApi.connectCQT(params)
    return res
  },
)
export const thunkDisconnectCQT = createAsyncThunk(
  '/input-invoice/disconnectCQT',
  async (params, thunkApi) => {
    const res = await invoiceApi.disconnectCQT(params)
    return res
  },
)
export const thunkSynchronizationCQT = createAsyncThunk(
  '/input-invoice/synchronizationCQT',
  async (params, thunkApi) => {
    const res = await invoiceApi.synchronizationCQT(params)
    return res
  },
)
export const thunkListOrganization = createAsyncThunk(
  '/input-invoice/getOrganization',
  async (params, thunkApi) => {
    const res = await invoiceApi.listOrganization(params)
    return res
  },
)
export const thunkCheckExistAccount = createAsyncThunk(
  '/input-invoice/checkExit',
  async (params, thunkApi) => {
    const res = await invoiceApi.checkExit(params)
    return res
  },
)
export const thunkCreataAccountService = createAsyncThunk(
  '/input-invoice/creataAccountService',
  async (params, thunkApi) => {
    const res = await invoiceApi.creataAccountService(params)
    return res
  },
)

export const thunkExportInvoiceInputInvoice = createAsyncThunk(
  '/input-invoice/exportInvoice',
  async (params, thunkApi) => {
    const res = await invoiceApi.exportInvoiceInputInvoice(params)
    return res
  },
)

const inputEinvoiceSlice = createSlice({
  name: 'inPutEinvoice',
  initialState: {
    profile: [],
    isGettingCustomer: false,
    pagination: { perPage: Global.gDefaultPagination, currentPage: 0 },
  },
  reducers: {
    setProfile: (state, action) => {
      return {}
    },
  },
  extraReducers: (builder) => {
    // get list money type
    builder.addCase(thunkGetProfile.pending, (state, action) => {
      state.isGettingMoneyType = true
    })

    builder.addCase(thunkCreateNewOrganization.pending, (state, action) => {
      state.isGettingMoneyType = true
    })
  },
})

const { actions, reducer } = inputEinvoiceSlice
export const { setProfile } = actions
export default reducer
